import { useAppStore } from '../store/AppStore'

export default function LookHowPopup () {
  const inputMethod = useAppStore((state) => state.inputMethod)

  return (
    <div className="bottom-[120px] left-0 right-0 absolute grid pointer-events-none content-center">
      <div className='text-white text-center'>
        {inputMethod === 'Drag' && <p>Drag your finder around the screen to look around the room</p>}
        {inputMethod === 'Gyro' && <p>Move your phone around to look around the room</p>}
      </div>
    </div>
  )
}
